import { useQuery } from "react-query";

import { TariffsService } from "~/entity/Tariffs/api/tariffsService";
import {
  IBaseTariffApi,
  IBaseTariffsListParams,
} from "~/entity/Tariffs/model/schema";

export const useGetBaseTariffsList = (params: IBaseTariffsListParams) => {
  const query = useQuery({
    queryKey: [TariffsService._routes.root, "base-tariffs", params],
    queryFn: async () => {
      const response = await TariffsService.GET.list(params);

      return {
        tariffs: response.data?.tariffs ?? [],
        total: response.data?.total ?? 0,
      };
    },
  });

  return {
    ...query,
    tariffs: query.data?.tariffs ?? ([] as IBaseTariffApi[]),
    total: query.data?.total ?? 0,
  };
};
